module.exports = new __parcel__URL__("73091265-1.6d190cfe.png").toString();